// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__359HR","actionsCol":"EnrolledClinics_actionsCol__hvu1O"};